import { PrismicRichText } from '@prismicio/react';
import { Hero } from 'remote-com-shared/components/Hero';
import { Label, ContentMain } from 'remote-com-shared/components/Hero/styles';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled from 'styled-components';

import { transformProperties } from '@/src/domains/prismic/helpers';

const CountryBenefitsHero = styled(Hero)`
  font-family: var(--typography-fontBrand);
  background: var(--newBrandColor);
  color: var(--colors-blank);
  max-height: auto;
  min-height: auto;

  ${Label} {
    color: var(--colors-blank);
    font-weight: 400;
    ${fluidProp('font-size', '32px', '48px')}
    text-transform: none;
    margin-bottom: 10px;
    margin-top: 0;
  }

  ${ContentMain} {
    padding-bottom: 50px;
  }
`;

const Title = styled.div`
  ${fluidProp('font-size', '62px', '92px')}
  font-weight: 700;
  line-height: 1;

  > * {
    margin: 0;
  }
`;

export function HeroSlice({ slice }) {
  const { primary, context } = transformProperties(slice);
  const { countryName } = context;

  const { label, title } = primary;

  return (
    <CountryBenefitsHero
      label={label || 'Remote Benefits:'}
      title={<Title>{title ? <PrismicRichText field={title} /> : countryName}</Title>}
      preview="0vh"
    />
  );
}
